var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from 'react';
import { css } from 'emotion';
import StatelessTable from './statelessTable';
import Typography from '../typography/index.react';
import Icon from '../icon/index.react';
import { sortButtonStyles } from './createStyle';
import spacing from '../../styles/spacing';

var sortItems = function sortItems(_a) {
  var items = _a.items,
      primaryField = _a.primaryField,
      secondaryField = _a.secondaryField,
      ascending = _a.ascending;
  return items.sort(function (a, b) {
    if (a[primaryField] > b[primaryField]) return ascending ? 1 : -1;
    if (a[primaryField] < b[primaryField]) return ascending ? -1 : 1;
    if (!secondaryField) return 0;
    if (a[secondaryField] > b[secondaryField]) return ascending ? 1 : -1;
    if (a[secondaryField] < b[secondaryField]) return ascending ? -1 : 1;
    return 0;
  });
};

var SortingTable = function SortingTable(_a) {
  var _b = _a.columns,
      columns = _b === void 0 ? [] : _b,
      initialSortingField = _a.initialSortingField,
      secondarySortingField = _a.secondarySortingField,
      _c = _a.onSortClick,
      onSortClick = _c === void 0 ? function () {} : _c,
      _d = _a.sort,
      sort = _d === void 0 ? sortItems : _d,
      _e = _a.initialAscending,
      initialAscending = _e === void 0 ? false : _e,
      props = __rest(_a, ["columns", "initialSortingField", "secondarySortingField", "onSortClick", "sort", "initialAscending"]);

  var _f = useState(initialSortingField || ''),
      field = _f[0],
      setField = _f[1];

  var _g = useState(initialAscending),
      ascending = _g[0],
      setAscending = _g[1];

  var items = sort({
    items: props.items,
    primaryField: field,
    secondaryField: secondarySortingField,
    ascending: ascending
  });

  var sortingLabel = function sortingLabel(fieldName, labelText) {
    if (fieldName === void 0) {
      fieldName = '';
    }

    if (labelText === void 0) {
      labelText = '';
    }

    return React.createElement("button", {
      className: sortButtonStyles,
      type: "button",
      onClick: function onClick() {
        var asc = field === fieldName ? !ascending : true;
        setField(fieldName);
        setAscending(asc);
        onSortClick(fieldName, asc);
      }
    }, React.createElement(Typography, {
      type: "caption"
    }, labelText), field === fieldName && React.createElement(Icon, {
      name: "arrow-down",
      rotation: ascending ? 180 : 0,
      size: "xs",
      className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            margin-left: ", ";\n          "], ["\n            margin-left: ", ";\n          "])), spacing.xxs)
    }));
  };

  var sortableColumns = columns.map(function (column) {
    var label = column.sortable ? sortingLabel(column.field, column.label) : column.label;
    return __assign(__assign({}, column), {
      label: label
    });
  });
  return React.createElement(StatelessTable, __assign({
    columns: sortableColumns
  }, props, {
    items: items
  }));
};

export default SortingTable;
var templateObject_1;